import Vue from 'vue';
import { install } from 'ga-gtag';
import sendMetrics from '@/utils/webVitals';
import 'slick-carousel/slick/slick.css';
import Partner from './views/partner.vue';
import Store from './store/store_partner.js';
import Router from './router/partner_router.js';
import './plugins/axios';

install(process.env.VUE_APP_PARTNER_GTAG_ID);
Vue.config.productionTip = false;
sendMetrics();

new Vue({
  router: Router,
  store: Store,
  render: h => h(Partner)
}).$mount('#app');
